import { passkeysGateway } from "@/gateways/passkeysGateway";
import { startRegistration } from "@simplewebauthn/browser";

export function usePasskeyRegistration() {
  return async (name: string | undefined) => {
    const { options, challengeId } =
      await passkeysGateway.getRegistrationOptions();
    const response = await startRegistration({ optionsJSON: options });
    await passkeysGateway.verifyRegistration({ response, name, challengeId });
  };
}
